<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Shit Happens!</h1><ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li><li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li><li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li><li id="toc-li-4"><a href="#/text/ch004#chapter-1">Chapter 1: Childhood Memories</a>
</li><li id="toc-li-6"><a href="#/text/ch005#chapter-2">Chapter 2: Junior Assistant Chemist at Deephams Sewage Works</a>
</li><li id="toc-li-8"><a href="#/text/ch006#chapter-3">Chapter 3: Assistant Pollution Inspector with Lee Conservancy Catchment Board</a>
</li><li id="toc-li-10"><span href="#/text/ch007#chapter-4" title="Link target outside of Sample">Chapter 4: Manager/Chemist and Trade Effluent Inspector with Brentwood Urban District Council</span>
</li><li id="toc-li-12"><span href="#/text/ch008#chapter-5" title="Link target outside of Sample">Chapter 5: Sewage Works Manager at Bishops Stortford Urban District Council</span>
</li><li id="toc-li-14"><span href="#/text/ch009#chapter-6" title="Link target outside of Sample">Chapter 6: Group Manager Bishops Stortford with Thames Water, Lee Division</span>
</li><li id="toc-li-16"><span href="#/text/ch010#chapter-7" title="Link target outside of Sample">Chapter 7: Group Manager Deephams</span>
</li><li id="toc-li-18"><span href="#/text/ch011#chapter-8" title="Link target outside of Sample">Chapter 8: Group Manager Luton</span>
</li><li id="toc-li-20"><span href="#/text/ch012#chapter-9" title="Link target outside of Sample">Chapter 9: The Reorganisation-Mad Thames Water Did It Again</span>
</li><li id="toc-li-22"><span href="#/text/ch013#chapter-10" title="Link target outside of Sample">Chapter 10: The Umpteenth Reorganisation Makes Several People Redundant</span>
</li><li id="toc-li-24"><span href="#/text/ch014#chapter-11" title="Link target outside of Sample">Chapter 11: From Leeds to Cairo</span>
</li><li id="toc-li-26"><span href="#/text/ch015#chapter-12" title="Link target outside of Sample">Chapter 12: From Cairo to Bangkok and Beyond</span>
</li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?093b61f3